import { useState } from "react";
import translate from "translate";

translate.engine = "google";
translate.key = undefined;

const useTranslate = () => {
  const [translatedMessages, setTranslatedMessages] = useState([]);

  const translateMessages = async (messages, targetLanguage) => {
    try {
      const translated = await Promise.all(
        messages?.map(async (text) => {
          const translatedText = await translate(text, targetLanguage);
          return translatedText;
        })
      );
      setTranslatedMessages(translated);
      return translated;
    } catch (error) {
      console.error("Translation failed. Please try again.");
      throw error;
    }
  };

  return { translatedMessages, translateMessages };
};

export default useTranslate;
